import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import AddForm from './components/AddForm/AddForm';

function RoleAddForm(props) {
  const { onClose, open, getData } = props;

  const TextFieldStyle = {
    paddingTop: 2,
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px'
  };

  const LabelStyle = {
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px'
  };

  const DialogWrapper = styled(Dialog)(
    () => `
          .MuiDialog-container {
              height: 100vh;
          }
          
          .MuiDialog-paperScrollPaper {
              max-height: calc(100vh - 80px);
          }
      `
  );

  const handleClose = () => {
    onClose();
  };

  return (
    <DialogWrapper
      open={open}
      keepMounted
      fullWidth
      maxWidth="md"
      scroll="paper"
      disableEscapeKeyDown
      onClose={() => handleClose()}
      onBackdropClick={() => {
        handleClose();
      }}
    >
      <AddForm
        LabelStyle={LabelStyle}
        TextFieldStyle={TextFieldStyle}
        onClose={onClose}
        getData={getData}
      />
    </DialogWrapper>
  );
}

RoleAddForm.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  getData: PropTypes.any
};

export default RoleAddForm;
